import { avalanche, avalancheFuji, base, defineChain } from "thirdweb/chains";

export const ACTIVE_CHAIN_ID = Number(process.env.REACT_APP_CHAIN_ID || 43114);
export const PONKE_CHAIN_ID = Number(process.env.REACT_APP_PONKE_CHAIN_ID || 8453);
export const RIPNDIP_CHAIN_ID = Number(process.env.REACT_APP_RIPNDIP_CHAIN_ID || 8453);
export const MEW_CHAIN_ID = Number(process.env.REACT_APP_MEW_CHAIN_ID || 43114);
export const NS_CHAIN_ID = Number(
  process.env.REACT_APP_NS_CHAIN_ID || 33139
);
export const MEW_RPC_URL = process.env.REACT_APP_MEW_RPC_URL;
export const RIPNDIP_RPC_URL = process.env.REACT_APP_RIPNDIP_RPC_URL;
export const NS_RPC_URL =
  process.env.REACT_APP_NS_RPC_URL || "https://rpc.apechain.com";
export const NS_CHAIN_NAME = process.env.REACT_APP_NS_CHAIN_NAME || "ApeChain";
export const NS_NATIVE_CURRENCY_NAME =
  process.env.REACT_APP_NS_NATIVE_CURRENCY_NAME || "ApeCoin";
export const NS_NATIVE_CURRENCY_SYMBOL =
  process.env.REACT_APP_NS_NATIVE_CURRENCY_SYMBOL || "APE";
export const NS_BLOCK_EXPLORER_NAME =
  process.env.REACT_APP_NS_BLOCK_EXPLORER_NAME || "ApeChain Explorer";
export const NS_BLOCK_EXPLORER_URL =
  process.env.REACT_APP_NS_BLOCK_EXPLORER_URL || "https://apescan.io";

export const ACTIVE_CHAIN = ACTIVE_CHAIN_ID === 43113 ? avalancheFuji : avalanche;
export const PONKE_CHAIN = base;
export const RIPNDIP_CHAIN =
  RIPNDIP_CHAIN_ID === 8453
    ? base
    : defineChain({
        id: RIPNDIP_CHAIN_ID,
        rpc: RIPNDIP_RPC_URL,
        name: "Base",
        nativeCurrency: {
          name: "Ether",
          symbol: "ETH",
          decimals: 18,
        },
        blockExplorers: [
          {
            name: "Basescan",
            url: "https://basescan.org",
          },
        ],
      });

// MEW uses Avalanche mainnet with custom RPC URL (mainnet only, no testnet)
export const MEW_CHAIN = defineChain({
  id: MEW_CHAIN_ID,
  rpc: MEW_RPC_URL,
  name: "Avalanche",
  nativeCurrency: {
    name: "Avalanche",
    symbol: "AVAX",
    decimals: 18,
  },
  blockExplorers: [
    {
      name: "Snowtrace",
      url: "https://snowtrace.io",
    },
  ],
});

export const NS_CHAIN = defineChain({
  id: NS_CHAIN_ID,
  rpc: NS_RPC_URL,
  name: NS_CHAIN_NAME,
  nativeCurrency: {
    name: NS_NATIVE_CURRENCY_NAME,
    symbol: NS_NATIVE_CURRENCY_SYMBOL,
    decimals: 18,
  },
  blockExplorers: NS_BLOCK_EXPLORER_URL
    ? [
        {
          name: NS_BLOCK_EXPLORER_NAME,
          url: NS_BLOCK_EXPLORER_URL,
        },
      ]
    : [],
});
